/*
 * File: assignPaymentMethod.tsx
 * Project: meki
 * File Created: Friday, 16th April 2021 7:56:49 am
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Thursday, 11th November 2021 3:50:32 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { gql } from '@apollo/client';
import { Order } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';

export const assignPaymentMethod = () => gql`
  mutation checkoutAssignPaymentMethod($params: AssignPaymentMethodParams!) {
    assignPaymentMethod(params: $params) {
      id
      uuid
      paymentMethod {
        id
      }
    }
  }
`;

export type AssignPaymentMethodMutationParams = ResolverParams<{
  orderUuid: string;
  paymentMethodUuid: string;
}>;

export type AssignPaymentMethodMutationResponse = {
  assignPaymentMethod: Pick<Order, 'id' | 'uuid'>;
};
